import { useContext, type JSX } from 'react';
import { useIntl } from 'react-intl';

import { FontSizes, FontWeights, Text } from '@calm-web/design-system';

import { MediaPlayerContext } from '@/components/app/contentPlayer/MediaPlayerProvider';
import Header from '@/components/header/Header';
import { useDeviceState } from '@/hooks/store';
import AppleStore from 'icons/apple-store.svg';
import DownloadGooglePlay from 'icons/download-google-play.svg';

import ContentDisplay from '../ContentDisplay';
import { ShareContext } from '../ShareProvider';
import messages from './messages';
import {
	ContentDisplayWrapper,
	DescriptionWrapper,
	DesktopContent,
	FlexWrapper,
	Icon,
	ImageContainer,
	MaybeLater,
	QRCode,
	QRCodePadding,
	QRCodeWrapper,
	WelcomeWrapper,
	Wrapper,
} from './styles';

function ShareHandoff(): JSX.Element {
	const device = useDeviceState();
	const { formatMessage } = useIntl();
	const { shouldShowShareHandoff, dismissHandoff } = useContext(ShareContext);
	const { playerMode, onPlay } = useContext(MediaPlayerContext);

	const onClose = () => {
		if (playerMode === 'paused') {
			onPlay();
		}
		dismissHandoff();
	};

	const AppStore = device.isMobile ? (device.os === 'AndroidOS' ? DownloadGooglePlay : AppleStore) : null;

	return (
		<Wrapper isVisible={shouldShowShareHandoff}>
			<Header isStatic hideLogo hideMenu hideProfile onExit={onClose} />
			<FlexWrapper>
				<WelcomeWrapper>
					<Text el="h1" styleAs="h4" color="gray7" weight={FontWeights.Medium}>
						{formatMessage(messages.handoffHeader)}
					</Text>
					<DescriptionWrapper>
						<Text el="p">{formatMessage(messages.handoffDescription)}</Text>
					</DescriptionWrapper>
				</WelcomeWrapper>
				<ContentDisplayWrapper>
					<ContentDisplay />
				</ContentDisplayWrapper>
				{AppStore ? (
					<Icon as={AppStore} />
				) : (
					<div>
						<Icon as={AppleStore} />
						<Icon as={DownloadGooglePlay} />
					</div>
				)}
				<br />
				<MaybeLater onClick={onClose}>{formatMessage(messages.maybeLater)}</MaybeLater>
				<ImageContainer>
					<DesktopContent>
						<Text el="p" color={'white'} weight={FontWeights.Demi} size={FontSizes.base}>
							{formatMessage(messages.scanQR, {
								br: <br />,
							})}
						</Text>
						<QRCodeWrapper>
							<QRCodePadding>
								<QRCode src={'/_n/images/handoff_no_ftue.png'} />
							</QRCodePadding>
						</QRCodeWrapper>
					</DesktopContent>
				</ImageContainer>
			</FlexWrapper>
		</Wrapper>
	);
}

export default ShareHandoff;
